// OBJECT DE TRADUCTIONS

const locale = Shopify.locale || 'de';

var formsTraductions = [
    {
        "id": 1,
        "div": "._teaserHeading_ou4pe_29",
        "fr": "Obtenir 10% de réduction",
        "en": "Get 10% discount"
    },
    {
        "id": 2,
        "div": "._textHeading_2aowh_35",
        "fr": "Maintenant -10% de réduction",
        "en": "Now -10% off"
    },
    {
        "id": 3,
        "div": "._formHeader_1ll8d_19 ._textBody_2aowh_10",
        "fr": "Reçois l'inspiration, les informations sur les nouveaux articles et les dernières offres dans ta boîte de réception.",
        "en": "Receive inspiration, information on new items and the latest offers in your inbox."
    },
    {
        "id": 4,
        "div": "._formSubmitButton_1ll8d_81",
        "fr": "S'inscrire gratuitement",
        "en": "Register for free"
    },
    {
        "id": 5,
        "div": "._formDisclaimer_1ll8d_37",
        "fr": "En envoyant ton adresse e-mail, tu acceptes de recevoir des e-mails marketing.",
        "en": "By submitting your e-mail address, you agree to receive marketing e-mails."
    },
    {
        "id": 6,
        "div": "._formBannerHeading_1t76a_9",
        "fr": "10% de réduction sur ta commande",
        "en": "10% discount on your order."
    },
    {
        "id": 7,
        "div": "._formBannerContainer_1t76a_1 div._textBody_2aowh_10",
        "fr": "Utilise ton bon immédiatement ! Ne s'applique pas aux articles gratuits.",
        "en": "Redeem your voucher now! Does not apply to free items."
    }
]


/* --------------------------------------------------------------
// -------------------------------------------------------------
-------------------------------------------------------------- */


const targetNode = document.body;
const observerConfig = {
    childList: true,
    subtree: true,
};

const observerCallback = (mutationsList, observer) => {
    for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
            mutation.addedNodes.forEach((node) => {
                if (node.tagName === 'FORM-EMBED') {
                    observer.disconnect();

                    var shadowContent = node.shadowRoot;
                    if (shadowContent) {
                        var container = shadowContent.querySelector("#app-embed");
                        formsTraductions.forEach(translation => {
                            var element = container.querySelector(`${translation.div}`);
                            if (element) element.textContent = translation[locale];
                        });
                    }

                    observeShadowContent(shadowContent);
                }
            });
        }
    }
};

if (locale == "en" || locale == "fr") {
    const observerTranslate = new MutationObserver(observerCallback);
    observerTranslate.observe(targetNode, observerConfig);
}

// Observe le moment de l'ouverture de la popup pour faire les traductions lors des changements dans la popup
function observeShadowContent(shadowContent) {

    const observerCallback = (mutationsList) => {
        for (const mutation of mutationsList) {
            if (mutation.type === 'childList') {
                mutation.addedNodes.forEach((node) => {
                    formsTraductions.forEach(translation => {
                        var element = node.querySelector(`${translation.div}`);
                        if (element) element.textContent = translation[locale];
                    });
                });
            }
        }
    };

    const observer = new MutationObserver(observerCallback);
    observer.observe(shadowContent, observerConfig);
}